export const COST_ENERGY_PER_KW = 0.08;
export const STEP_ENERGY = 100;
